import { memo } from "react";
import Box from '@mui/material/Box';
import CodeSnippet, { type CodeSnippetProps } from "ui/molecules/CodeSnippet";

const QueryBuilderDisplayPayload = (props: CodeSnippetProps) => (
    <Box
        sx={{
            mt: 2
        }}
    >
        <CodeSnippet
            {...props}
        />
    </Box>
);

export default memo(QueryBuilderDisplayPayload);
